import InvalidArgumentException from "Exceptions/invalidArgumentException";

export default class ProductOptions {
	constructor({ id }) {
		if (id === null || id === undefined) throw new InvalidArgumentException("id", id);

		this.id = id;
	}
}